<template>
    <!-- blog -->
    <div>
        <div class="mail-top" @click="openModal('modal-form')" title="Kontaktiraj nas"><span class="icon"><i class="fa fa-envelope"></i></span></div>
        <app-modal :id="'modal-form'" v-if="openedModal==='modal-form'" @close="closeModal" role="dialog">
            <div slot="header" class="mtb-20">
                <h1 class="title">Piši mi </h1>
            </div>
            <div slot="body" class="mtb-20">
                <app-contact-form></app-contact-form>
            </div>
        </app-modal>
        <app-stycky label="Kategorije" :items="items" type="tag" :route="'/blog/'" ></app-stycky>
    </div>
</template>

<script>

import StickyButton from './StickyButton.vue';
import ContactForm from '../elements/form/ContactForm';
import Modal from './Modal.vue';
import ModalMixin from '../../mixins/ModalMixin';

export default {
    name: 'app-mail-categories-stycky',
    props: ['items'],
    mixins: [ModalMixin],
    data() {
        return {
            isOpen: false
        }
    },

    components: {
        'app-stycky': StickyButton,
        'app-modal': Modal,
        'app-contact-form': ContactForm,
    },

    computed: {

    },

    methods: {

    },

    created() {

    }
}
</script>


<style lang="scss">

@import "../../style/app.scss";

.stycky-btn{
    // position: fixed;
    // top: 40%;
    // left: 0;
    margin: 5px 0 0 50px;
    z-index:100;
    cursor: pointer;
    transition: all .2s ease-in-out;
    &:first-child{
        top: 35%;
    }
    .is-rounded-right {
        border-bottom-left-radius: 0;
        border-top-left-radius: 0;
        border-bottom-right-radius: 290486px;
        border-top-right-radius: 290486px;
        height: 50px;
        padding: 20px 30px;
        font-size: 2rem;
        border: 4px solid $th-black-05;
        /* &:hover {
            padding: 20px 60px;
        } */
    }
    ul {
        display: block;
        width: 100%;
        clear: both;
        // padding: 30px 0;
        line-height: 1.5;
        font-size: 1.5rem;
        // margin: -10px 0 0 -60px;
        z-index: 101;
        background: $white;
        position: absolute;
        top: 50px;
        left:0;
        padding: 10px 0;
        li {
            text-transform: capitalize;
            // margin-left: -20px;
            a {
                padding: 0.3rem 3rem;
                // background: white;
                // border-radius: 0 30px 30px 0;
                display: inline-block;
                margin-bottom: 5px;
                box-shadow: 0px 2px 0 0 rgba(0,0,0,0.1);
                &:hover{
                    transition: 0.15s padding ease-out;
                }
            }
        }
    }
    &.is-large {
        padding: 20px 60px;
    }
    .tag-text {
        padding-left: 20px;
    }
    .sticky-tag {
        color: $th-black-05 !important;
    }
    .tag:not(body) {
        background-color: transparent;
        // background-color: $th-black-01;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/layout/MailCategoriesSticky.vue